export const mapResponsablesToDTO = (responsables: any[]) => {
    return responsables.map((r) => ({
        idCargo: r.idCargo !== undefined && r.idCargo !== null ? Number(r.idCargo) : null,
        nombre: r.nombre,
        apellido: r.apellido,
        cuitCuilCuip: r.cuit,
        tituloHabilitante: r.titulo,
        nroMatricula: r.matricula,
        entidadOtorgante: r.entidadOtorgante,
        idTipoContratacion:
            r.idTipoContratacion !== undefined &&
            r.idTipoContratacion !== null &&
            r.idTipoContratacion !== ''
                ? Number(r.idTipoContratacion)
                : null,
        idRepresentacion:
            r.idRepresentacion !== undefined &&
            r.idRepresentacion !== null &&
            r.idRepresentacion !== ''
                ? Number(r.idRepresentacion)
                : null
    }));
};
